<template>
  <div>
    <data-table ref="dataTable" :option="option">
      <template slot="headAction">
        <a-button
          style="margin-left:10px"
          type="primary"
          @click="qermission('1')"
          >菜单权限</a-button
        >
        <a-button
          style="margin-left:10px"
          type="primary"
          @click="roleQermission"
          >功能权限</a-button
        >
        <!-- <a-button style="margin-left:10px" type="primary" @click="qermission('3')">角色仓库权限</a-button>
        <a-button style="margin-left:10px" type="primary" @click="qermission('4')">角色部门权限</a-button>-->
        <a-button
          style="margin-left:10px"
          type="primary"
          @click="roleReportQermission"
          >报表权限</a-button
        >
      </template>
    </data-table>
    <checkbox-tree
      :title="title"
      :visible="visible.qermissionModal"
      :option="qermissionOption"
      :type="treeType"
      @submit="onSubmit"
      @close="onClose"
    />
    <a-modal
      centered
      :maskClosable="visible.maskClosable"
      title="报表权限"
      v-model="visible.roleReportQermissionModal"
      width="60%"
      @ok="handleOk"
    >
      <div>
        <a-layout id="components-layout-demo-side" style="height: 100%">
          <a-layout-sider>
            <a-tree
              style="overflow:auto;height:100%"
              :treeData="treeData"
              @select="onSelect"
              :selectedKeys.sync="selectedKeys"
            ></a-tree>
          </a-layout-sider>
          <a-layout>
            <div>
              <div style="padding:8px;background: white;">
                <a-button
                  style="margin-left:5px"
                  type="primary"
                  @click="selectAll(true)"
                  >全选</a-button
                >
                <a-button
                  style="margin-left:10px"
                  type="primary"
                  @click="selectAll(false)"
                  >取消全选</a-button
                >
              </div>
              <data-grid
                :columns="columns"
                v-model="dataShow"
                rowKey="DataId"
                bordered
              />
              <!-- {{data}} -->
            </div>
          </a-layout>
        </a-layout>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { DataTable } from "@/components/dataTable";
import { DataGrid } from "@/components/dataGrid";
import CheckboxTree from "@/components/dataTree/CheckboxTree";
import RoleQermission from "./funtion.js";

export default {
  name: "userManage_role",
  components: { DataTable, DataGrid, CheckboxTree },
  props: {},
  data() {
    return {
      //form: this.form.createForm(this),
      visible: {
        maskClosable: false,
        qermissionModal: false,
        roleQermissionModal: false,
        roleReportQermissionModal: false
      },
      qermissionOption: {
        id: "",
        api: "",
        valueField: "Code", //可选项数据值字段
        textField: "Name", //可选项数据文本字段
        children: "Childs",
        parentNode: false
      },
      title: "",
      treeType: "",
      selectedKeys: [],
      columns: [
        {
          title: "名称",
          dataIndex: "Name",
          width: "200px"
        },
        {
          title: "浏览",
          dataIndex: "CanPreview",
          width: "100px",
          edit: {
            type: "checkbox"
          }
        },
        {
          title: "打印",
          dataIndex: "CanPrint",
          width: "100px",
          edit: {
            type: "checkbox"
          }
        },
        {
          title: "导出",
          dataIndex: "CanExport",
          width: "100px",
          edit: {
            type: "checkbox"
          }
        },
        {
          title: "移动端",
          dataIndex: "CanMobile",
          width: "100px",
          edit: {
            type: "checkbox"
          }
        }
      ],
      data: [],
      dataShow: [],
      treeData: [] //角色报表权限左侧树
    };
  },
  created() {
    this.option = {
      // headSearch: {
      //   colnum: 2,
      //   content: []
      // },
      form: {
        colnum: 1,
        width: 500,
        title: "角色",
        add: {
          submitApi: "Role_Add",
          onOpenAfter: () => {
            const form = this.$refs.dataTable.getForm();
            form.setFieldData("DefaultMenuId", []);
            return { ValidStatus: 1, DefaultMenuId: null };
          }
        },
        edit: {
          infoApi: "Role_Get",
          submitApi: "Role_Edit",
          onOpenAfter: value => {
            this.$post("Common_GetRoleMenu", {
              Id: value.Data.Id
            }).then(res => {
              const form = this.$refs.dataTable.getForm();
              if (res.Data && res.Data.length > 0) {
                form.setFieldData("DefaultMenuId", res.Data);
                form.updateData();
              } else {
                form.setFieldData("DefaultMenuId", []);
              }
            });
            if (value.Data.DefaultMenuId == "0") {
              value.Data.DefaultMenuId = null;
              return value.Data;
            }
          }
        },
        del: { submitApi: "Role_Del" },
        content: [
          {
            label: "编码",
            name: "Code",
            option: {
              rules: [{ required: true, message: "请填写编码！" }]
            }
          },
          {
            label: "名称",
            name: "Name",
            option: {
              rules: [{ required: true, message: "请填写名称！" }]
            }
          },
          {
            label: "默认菜单",
            name: "DefaultMenuId",
            type: "select"
            // api: "Common_GetSelect",
            // param: { types: "menu" },
            // dataField: "Data.menu"
          },
          {
            label: "描述",
            name: "Description"
          },
          {
            label: "状态",
            name: "ValidStatus",
            option: {
              rules: [{ required: true, message: "请选择状态！" }]
            },
            placeholder: "请选择",
            type: "select",
            valueField: "value", //可选项数据值字段
            textField: "text", //可选项数据文本字段
            data: [
              {
                value: 0,
                text: "不启用"
              },
              {
                value: 1,
                text: "启用"
              }
            ]
          }
        ]
      },
      grid: {
        api: "Role_List",
        //pagination: false,
        //dataField: "Data",
        columns: [
          {
            title: "序号",
            width: "6%", //宽度
            align: "center", //对齐方式
            type: "indexcolumn" // 类型，indexcolumn = 序号
          },
          {
            title: "编码",
            width: "15%",
            dataIndex: "Code"
          },
          {
            title: "名称",
            width: "15%",
            dataIndex: "Name"
          },
          {
            title: "默认菜单",
            width: "15%",
            dataIndex: "DefaultMenu"
          },
          {
            title: "状态",
            width: "15%",
            dataIndex: "ValidStatus",
            customRender: text => {
              if (text) {
                return <a-badge status="success" text="启用" />;
              } else {
                return <a-badge status="error" text="不启用" />;
              }
            }
          },
          {
            title: "描述",
            dataIndex: "Description"
          },

          {
            title: "操作",
            dataIndex: "Id",
            width: "15%",
            key: "action",
            //插槽 ，rowAction 默认的 编辑、删除 操作按钮插槽，如需其它按钮需自行定义插槽
            scopedSlots: { customRender: "rowAction" }
          }
        ]
      }
    };
  },
  mounted() {},
  activited() {},
  update() {},
  beforeRouteUpdate() {},
  methods: {
    //选择的树节点
    onSelect(selectedKeys) {
      this.dataShow = [];
      if (selectedKeys == "0") this.dataShow = this.data;
      else {
        this.data.forEach(item => {
          if (item.ReportGroupId == selectedKeys) this.dataShow.push(item);
        });
      }
    },
    qermission(type) {
      let row = this.$refs.dataTable.getSelected();
      if (!row) {
        this.$message.info("请先选择一条数据！");
        return false;
      }
      if (type == "1") {
        this.title = "菜单权限";
        this.qermissionOption.api = "Role_GetRoleMenus";
      } else if (type == "2") {
        this.title = "角色权限";
        this.qermissionOption.api = "Role_GetRolePermissions";
      } else if (type == "3") {
        this.title = "角色仓库权限";
        this.qermissionOption.api = "Role_SetRoleReportDataPermission";
      } else if (type == "4") {
        this.title = "角色部门权限";
        this.qermissionOption.api = "Role_SetRoleReportDataPermission";
      }
      this.qermissionOption.id = row.Id;
      this.visible.qermissionModal = true;
      this.treeType = type;
    },
    roleQermission() {
      let row = this.$refs.dataTable.getSelected();
      if (!row) {
        this.$message.info("请先选择一条数据！");
        return false;
      }
      //this.visible.roleQermissionModal = true;
      RoleQermission({ roleId: row.Id });
    },
    roleReportQermission() {
      let row = this.$refs.dataTable.getSelected();
      if (!row) {
        this.$message.info("请先选择一条数据！");
        return false;
      }
      this.$post("Role_GetReportGroupsAsync", {}).then(res => {
        let arr = [{ key: 0, title: "全部" }];
        res.Data.forEach(item => {
          arr.push({ key: item.Id, title: item.Name });
        });
        this.treeData = arr;
      });
      this.$post("Role_GetReportPermissions", { RoleId: row.Id }).then(res => {
        this.selectedKeys = [];
        this.data = res.Data;
        this.dataShow = this.data;
      });
      this.visible.roleReportQermissionModal = true;
    },
    //角色报表权限全选
    selectAll(value) {
      this.dataShow.forEach(item => {
        item.CanExport = value;
        item.CanMobile = value;
        item.CanPreview = value;
        item.CanPrint = value;
      });
    },
    //角色报表权限提交
    handleOk() {
      let row = this.$refs.dataTable.getSelected();
      this.data.forEach(item => {
        item.RoleId = row.Id;
      });
      this.$post("Role_SetRoleReportDataPermission", this.data).then(() => {
        this.$message.info("操作成功");
        this.visible.roleReportQermissionModal = false;
      });
    },
    //菜单权限提交
    onSubmit(type, treeData, checkedKeys) {
      let row = this.$refs.dataTable.getSelected();
      const json = { RoleId: row.Id, MenuCodes: checkedKeys };
      let url = "";
      if (type == "1") url = "Role_SetRoleMenus";
      else if (type == "2") url = "Role_SetPermissions";
      else if (type == "3") url = "Role_SetRoleReportDataPermission";
      else if (type == "4") url = "Role_SetRoleReportDataPermission";

      this.$post(url, json).then(() => {
        this.visible.qermissionModal = false;
        this.$message.success("操作成功！");
      });
    },
    //菜单权限关闭弹窗
    onClose() {
      this.visible.qermissionModal = false;
    }
  },
  filter: {},
  // 计算属性
  computed: {},
  watch: {}
};
</script>

<style lang="less" scoped>
.ant-layout-sider {
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
  position: relative;
  background: white;
  min-width: 0;
}
</style>
